<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics

========================================================================================== -->

<template>
	<div id="cbs-dashboard" class="cbs-dashboard">
		<div class="vx-row" v-if="$store.state.dashboardManagement.isFetchedDevices && $store.state.dashboardManagement.devices.length === 0">
			<div class="vx-col w-full mb-base">
				<vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
					<img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" />
					<img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175" />
					<feather-icon icon="AwardIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
					<h1 class="mb-6 text-white">Chào mừng {{ activeUserInfo.role && activeUserInfo.role.name }},</h1>
					<p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
						Cảm ơn đã sử dụng dịch vụ của
						<strong>CanhBaoSom</strong>
					</p>
				</vx-card>
			</div>
		</div>

		<section v-if="mixinIsCanViewAllEmployee && $store.state.AppActiveUser.cluster_id === 100" class="section cbs-dashboard__section mb-base">
			<ListActivities/>
		</section>
		<section v-if="$store.getters['auth/checkConfigDashboard']('list_requests') && mixinIsCanViewRequest" class="section cbs-dashboard__section mb-base">
			<list-requests @onIsRequestFormDirtyChange="handleSetIsRequestFormDirty" />
		</section>
		<section v-if="$store.getters['auth/checkConfigDashboard']('list_devices') && mixinIsCanViewDevice" class="section cbs-dashboard__section mb-base">
			<list-devices />
		</section>

		<!-- <section v-if="$store.getters['auth/checkConfigDashboard']('list_device_alerts') && mixinIsCanViewDevice" class="section cbs-dashboard__section mb-base">
			<list-sensor-warnings />
		</section> -->

		<section v-if="$store.getters['auth/checkConfigDashboard']('list_todo_assigned_to_me') && mixinIsCanViewTodo" class="section cbs-dashboard__section mb-base">
			<list-todo-assigned-to-me />
		</section>

		<section v-if="$store.getters['auth/checkConfigDashboard']('list_todo_statistics') && mixinIsCanViewTodo" class="section cbs-dashboard__section mb-base">
			<list-todo-statistics />
		</section>

		<section class="section cbs-dashboard__section mb-base">
			<RequestsStatistics />
		</section>
	</div>
</template>

<script>
import moduleDashboard from "@/store/dashboard/moduleDashboard";

import ListActivities from "./ListActivities";
import ListDevices from "./ListDevices";
import ListRequests from "./ListRequests";
import ListSensorWarnings from "./ListSensorWarnings";
import ListTodoStatistics from "./ListTodoStatistics";
import ListTodoAssignedToMe from "./ListTodoAssignedToMe";
import RequestsStatistics from "./RequestsStatistics";

import { getUserPermissions, devicePermissions, employeePermissions, requestPermissions, todoPermissions, detectLeavePage } from "@/mixins/mixins.js";

export default {
	mixins: [getUserPermissions({ ...devicePermissions, ...employeePermissions, ...requestPermissions, ...todoPermissions }), detectLeavePage("isRequestFormDirty")],
	data() {
		return {
			timelineData: [
				{
					color: "primary",
					icon: "PlusIcon",
					title: "Khách hàng đăng ký và sử dụng dịch vụ",
					desc: "Đăng ký dịch vụ tương ứng với quy mô doanh nghiệp.",
					time: "25 mins Ago"
				},
				{
					color: "warning",
					icon: "MailIcon",
					title: "Phát hành thư thông báo đến khách hàng",
					desc: "Gửi thư thông báo đến quý khách hàng giới thiệu về dịch vụ CBS.",
					time: "15 Days Ago"
				},
				{
					color: "danger",
					icon: "UsersIcon",
					title: "Kiểm thử nội bộ",
					desc: "Đội ngũ CMA cùng nhau trải nghiệm dịch vụ thông qua phiên bản Beta.",
					time: "20 days ago"
				},
				{
					color: "success",
					icon: "LayoutIcon",
					title: "Website CanhBaoSom được phát hành beta.",
					desc: "Áp dụng nền tảng SaaS, CBS đem đến dịch vụ nhanh chóng và phản hồi hiệu quả.",
					time: "25 days ago"
				},
				{
					color: "primary",
					icon: "TvIcon",
					title: "Lên kế hoạch dự án CanhBaoSom",
					desc:
						"Dự án được ban giám đốc thông qua và tiến hành xây dựng. Cùng toàn thể đội ngũ của CMA, dự án được chăm chút phát triển với mong muốn đem lại sự trải nghiệm dịch vụ của quý khách hàng tốt nhất.",
					time: "28 days ago"
				}
			],

			isRequestFormDirty: false
		};
	},
	components: {
		ListActivities,
		ListDevices,
		ListRequests,
		ListSensorWarnings,
		ListTodoStatistics,
		ListTodoAssignedToMe,
		RequestsStatistics
	},
	computed: {
		// PROFILE
		activeUserInfo() {
			return this.$store.state.AppActiveUser;
		}
	},
	methods: {
		handleSetIsRequestFormDirty(isFormDirty) {
			this.isRequestFormDirty = isFormDirty;
		}
	},
	created() {
		this.$store.registerModule("dashboardManagement", moduleDashboard);
		const { cluster_id, role } = this.$store.state.AppActiveUser;
		if (this.$socket) {
			cluster_id && this.$socket.emit("my-cluster-is", cluster_id);
			role.id && this.$socket.emit("my-id-is", role.id);
		}
	},
	mounted() {
		try {
			if (this.sockets) {
				this.sockets.subscribe("sensors", data => {
					const item = data.data;
					switch (item.event) {
						case "remove_sensor_alert":
							this.$store.commit("dashboardManagement/REMOVE_SENSOR_ALERT", item);
							break;
						case "sensor_over_threshold":
							this.$store.commit("dashboardManagement/UPDATE_SENSOR_ALERT", item);
							break;
						case "sensor_change":
							this.$store.commit("dashboardManagement/UPDATE_SENSOR_IN_DEVICE", item);
							break;
					}

					if (item.actor_type == "Comay\\Cmcbs\\Models\\Sensor") {
						this.$store.commit("dashboardManagement/UPDATE_SENSOR_IN_DEVICE", item);
					}
				});
			}
		} catch (exx) {
			console.log(exx.message);
		}
	},
	beforeDestroy() {
		this.$store.unregisterModule("dashboardManagement");
		if (this.sockets) {
			this.sockets.unsubscribe("sensors");
		}
	}
};
</script>

<style lang="scss">
@import "@/assets/scss/cbs/Dashboard.scss";
</style>
